module.exports = __webpack_public_path__ + "img/logo_blue_52.b5988612.png";